export const cellEditors = {
  TEXT: "TextEditor",
  TRANSITION: "TransitionStateEditor",
};
